import React, { useState } from 'react';
import { Bar } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Tooltip,
  Legend,
} from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import { Box, FormControlLabel, Checkbox, IconButton, Tooltip as MuiTooltip, Dialog, DialogTitle, DialogContent, DialogActions, Button } from '@mui/material';
import InfoIcon from '@mui/icons-material/Info';
import { useData } from '../context/DataContext';

ChartJS.register(CategoryScale, LinearScale, BarElement, Tooltip, Legend, ChartDataLabels);

const EntregasATiempoBar = ({ selectedIndustries = [], onBarClick = () => {} }) => {
  const [infoOpen, setInfoOpen] = useState(false);
  const { getTransportDelivery, dataReady } = useData();

  // Get data from Excel (3 years) - Q15: Entregas a tiempo del transporte
  const excelData = dataReady ? getTransportDelivery() : { labels: [], data2022: [], data2023: [], data2024: [] };

  // Use Excel data or fallback
  const allLabels = excelData.labels.length > 0
    ? excelData.labels
    : ['Sector salud/ Farmacéuticas', 'Alimentos', 'Servicios Logísticos', 'Construcción', 'Automotriz', 'Retail', 'Manufactura'];

  const allData2022 = excelData.data2022.length > 0 ? excelData.data2022 : [90, 91, 91, 85, 93, 91, 94];
  const allData2023 = excelData.data2023.length > 0 ? excelData.data2023 : [100, 92, 93, 91, 89, 80, 85];
  const allData2024 = excelData.data2024.length > 0 ? excelData.data2024 : [90, 94, 94, 92, 93, 90, 93];

  const labels = selectedIndustries.length > 0 ? selectedIndustries : allLabels;

  const getValuesForLabels = (allValues) => labels.map((label) => {
    const index = allLabels.indexOf(label);
    return index !== -1 ? allValues[index] : 0;
  });

  const chartData = {
    labels,
    datasets: [
      {
        label: '2023',
        data: getValuesForLabels(allData2022),
        backgroundColor: '#A2AEBB',
        borderColor: '#fff',
        borderWidth: 0,
      },
      {
        label: '2024',
        data: getValuesForLabels(allData2023),
        backgroundColor: '#476A8E',
        borderColor: '#fff',
        borderWidth: 0,
      },
      {
        label: '2025',
        data: getValuesForLabels(allData2024),
        backgroundColor: '#1F3D58',
        borderColor: '#fff',
        borderWidth: 0,
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    indexAxis: 'y',
    plugins: {
      legend: {
        display: true,
        position: 'top',
      },
      tooltip: {
        callbacks: {
          label: (context) => `${context.dataset.label}: ${context.raw}%`,
        },
      },
      datalabels: {
        color: '#000',
        font: { weight: 'bold', size: 10 },
        anchor: 'end',
        align: 'right',
        offset: 8,
        formatter: (value) => `${value}%`,
        clip: false,
      },
    },
    scales: {
      x: {
        beginAtZero: true,
        max: 110,
        ticks: {
          stepSize: 10,
        },
        title: {
          display: true,
          text: 'Porcentaje (%)',
        },
      },
      y: {
        ticks: {
          font: { size: 14 },
        },
        title: {
          display: true,
          text: 'Industria',
        },
      },
    },
  };

  const handleSegmentClick = (industry) => {
    let updatedSelectedIndustries = [...selectedIndustries];
    if (updatedSelectedIndustries.includes(industry)) {
      updatedSelectedIndustries = updatedSelectedIndustries.filter((item) => item !== industry);
    } else {
      updatedSelectedIndustries.push(industry);
    }
    onBarClick(updatedSelectedIndustries);
  };

  const handleCheckboxChange = (industry) => {
    handleSegmentClick(industry);
  };

  const infoContent = {
    formula: 'Entregas a Tiempo (%) = (Número de entregas a tiempo / Número total de entregas) × 100',
    description: 'Mide el porcentaje de pedidos surtidos a tiempo y entregados, por las unidades de transporte (propias y/o tercerizadas), al cliente en la fecha y hora compromiso.',
  };

  return (
    <div style={{ maxWidth: '800px', height: '500px', margin: '0 auto', padding: '20px' }}>
      <Box display="flex" justifyContent="space-between" alignItems="center" mb={-5}>
        <MuiTooltip title="Información de la gráfica">
          <IconButton onClick={() => setInfoOpen(true)}>
            <InfoIcon />
          </IconButton>
        </MuiTooltip>
      </Box>
      <Box display="flex" justifyContent="center" flexWrap="wrap" mb={2}>
        {allLabels.map((industry) => (
          <FormControlLabel
            key={industry}
            control={
              <Checkbox
                checked={selectedIndustries.includes(industry)}
                onChange={() => handleCheckboxChange(industry)}
                color="primary"
              />
            }
            label={industry}
          />
        ))}
      </Box>
      <div style={{ width: '100%', height: '420px' }}>
        <Bar data={chartData} options={options} />
      </div>

      <Dialog open={infoOpen} onClose={() => setInfoOpen(false)}>
        <DialogTitle>Información de la Gráfica</DialogTitle>
        <DialogContent>
          <p><strong>Fórmula:</strong> {infoContent.formula}</p>
          <p><strong>Descripción:</strong> {infoContent.description}</p>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setInfoOpen(false)} color="primary">
            Cerrar
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default EntregasATiempoBar;
